import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/auth/AuthContext'
import { ProtectedRoute } from '@/auth/ProtectedRoute'
import { AppLayout } from '@/components/layout/AppLayout'
import { Settings } from '@/pages/Admin/Settings'
import { IngestStatus } from '@/pages/Admin/IngestStatus'
import { SyncControl } from '@/pages/Admin/SyncControl'
import { UserManagement } from '@/pages/Admin/UserManagement'
import { AgentDetail } from '@/pages/AgentDetail'
import { Agents } from '@/pages/Agents'
import { ChangePassword } from '@/pages/ChangePassword'
import { CustomerDetail } from '@/pages/CustomerDetail'
import { Customers } from '@/pages/Customers'
import { Dashboard } from '@/pages/Dashboard'
import { Login } from '@/pages/Login'
import { MfaSetup } from '@/pages/MfaSetup'
import { Reports } from '@/pages/Reports'
import { ThreatDown } from '@/pages/ThreatDown'
import { ThreatDownDetections } from '@/pages/ThreatDownDetections'
import { ThreatDownEndpointDetail } from '@/pages/ThreatDownEndpointDetail'
import { Defender } from '@/pages/Defender'
import { DefenderDetections } from '@/pages/DefenderDetections'
import { Backup } from '@/pages/Backup'
import { Nas } from '@/pages/Nas'
import { Assistant } from '@/pages/Assistant'

function CustomersRoute() {
  const { isCustomer, user } = useAuth()
  if (isCustomer) {
    const ids = Array.isArray(user?.customer_ids) ? user.customer_ids : []
    if (ids.length === 1) {
      return <Navigate to={`/customers/${ids[0]}`} replace />
    }
    if (ids.length === 0 && user?.customer_id) {
      return <Navigate to={`/customers/${user.customer_id}`} replace />
    }
    if (ids.length === 0) {
      return <Navigate to="/" replace />
    }
  }
  return <Customers />
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute requireMfa={false} />}>
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/mfa/setup" element={<MfaSetup />} />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<CustomersRoute />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="agents">
                <Route index element={<Agents />} />
                <Route path=":id" element={<AgentDetail />} />
              </Route>
              <Route path="nas" element={<Nas />} />
              <Route path="reports" element={<Reports />} />
              <Route path="backup" element={<Backup />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="threatdown" element={<ThreatDown />} />
              <Route path="threatdown/detections" element={<ThreatDownDetections />} />
              <Route path="threatdown/endpoints/:id" element={<ThreatDownEndpointDetail />} />
              <Route path="defender" element={<Defender />} />
              <Route path="defender/detections" element={<DefenderDetections />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute requireAdmin />}>
            <Route element={<AppLayout />}>
              <Route path="admin/users" element={<UserManagement />} />
              <Route path="admin/settings" element={<Settings />} />
              <Route path="admin/sync" element={<SyncControl />} />
              <Route path="admin/ingest" element={<IngestStatus />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
